// Make sure to run npm install @formspree/react
// For more help visit https://formspr.ee/react-help
import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import "./contactForm.css";
import { Typography } from "@mui/material";

function ContactForm() {
  const [state, handleSubmit] = useForm("mqalywjv");
  if (state.succeeded) {
    return (
      <div className="contact-form-container">
        <div className="contact-form-wrapper">
          <p className="contact-form-success-message">Te estaremos contactando pronto!</p>
        </div>
      </div>
    );
  }
  return (
    <div className="contact-form-container">
      <div className="contact-form-wrapper">
        <Typography variant="h3" className="contact-form-title">
          Formulario de contacto
        </Typography>
        <form
          onSubmit={handleSubmit}
          action="https://formspree.io/f/mqalywjv"
          method="POST"
          className="contact-form"
        >
          <div className="contact-form-name-row">
            <div className="contact-form-group">
              <label htmlFor="nombre" className="contact-form-label">
                Nombre
              </label>
              <input
                id="nombre"
                type="text"
                name="nombre"
                className="contact-form-input"
                placeholder="Ingresa tu nombre"
                required
              />
              <ValidationError
                prefix="Nombre"
                field="nombre"
                errors={state.errors}
              />
            </div>

            <div className="contact-form-group">
              <label htmlFor="apellido" className="contact-form-label">
                Apellido
              </label>
              <input
                id="apellido"
                type="text"
                name="apellido"
                className="contact-form-input"
                placeholder="Ingresa tu apellido"
                required
              />
              <ValidationError
                prefix="Apellido"
                field="apellido"
                errors={state.errors}
              />
            </div>
          </div>

          <div className="contact-form-name-row">
            <div className="contact-form-group">
              <label htmlFor="telefono" className="contact-form-label">
                Teléfono
              </label>
              <input
                id="telefono"
                type="tel"
                name="telefono"
                className="contact-form-input"
                placeholder="1234-5678"
                pattern="[0-9]{4}-[0-9]{4}"
                title="Por favor ingresa un número de teléfono válido (ej: 1234-5678)"
                maxLength="9"
                required
              />
              <ValidationError
                prefix="Teléfono"
                field="telefono"
                errors={state.errors}
              />
            </div>

            <div className="contact-form-group">
              <label htmlFor="cumpleanos" className="contact-form-label">
                Cumpleaños
              </label>
              <input
                id="cumpleanos"
                type="date"
                name="cumpleanos"
                className="contact-form-input"
                required
              />
              <ValidationError
                prefix="Cumpleaños"
                field="cumpleanos"
                errors={state.errors}
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={state.submitting}
            className="contact-form-button"
          >
            {state.submitting ? "Enviando..." : "Enviar"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
